// Local
import ReconciliationPage from "./ReconciliationPage";
import CashReconciliationContainer from "./CashReconciliationContainer";
import ChecksReconciliationContainer from "./ChecksReconciliationContainer";
import AchReconciliationContainer from "./AchReconciliationContainer";
import CreditCardReconciliationContainer from "./CreditCardReconciliationContainer";
import AllPaymentsReconciliationContainer from "./AllPaymentsReconciliationContainer";
import { useSiteKeyDocStore } from "../../store/site-key-doc";
import React from "react";

interface Props {
  siteKey: string;
}

export default function ReconciliationContainer(props: Props): JSX.Element {
  const siteKey = props.siteKey;

  const siteKeyDoc = useSiteKeyDocStore((state) => state.siteKeyDoc);

  // Check if Quickbooks integration is enabled - moved outside of the conditional
  const isQuickbooksEnabled: boolean = React.useMemo(() => {
    return siteKeyDoc
      ? siteKeyDoc?.customizations?.accounting?.pushToCodat ||
          siteKeyDoc?.customizations?.accounting?.pushToConductor ||
          siteKeyDoc?.customizations?.accounting?.pushToQBO
      : false;
  }, [siteKeyDoc]);

  if (!siteKeyDoc) {
    return <div>Loading...</div>;
  }

  return (
    <ReconciliationPage
      siteKey={siteKey}
      quickbooksEnabled={isQuickbooksEnabled}
    >
      {{
        allPaymentsSlot: (
          <AllPaymentsReconciliationContainer
            siteKey={siteKey}
            quickbooksEnabled={isQuickbooksEnabled}
          />
        ),
        creditCardSlot: (
          <CreditCardReconciliationContainer
            siteKey={siteKey}
            quickbooksEnabled={isQuickbooksEnabled}
          />
        ),
        cashSlot: (
          <CashReconciliationContainer
            siteKey={siteKey}
            quickbooksEnabled={isQuickbooksEnabled}
          />
        ),
        checksSlot: (
          <ChecksReconciliationContainer
            siteKey={siteKey}
            quickbooksEnabled={isQuickbooksEnabled}
          />
        ),
        achSlot: (
          <AchReconciliationContainer
            siteKey={siteKey}
            quickbooksEnabled={isQuickbooksEnabled}
          />
        ),
      }}
    </ReconciliationPage>
  );
}
